module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading'), _vm._v(" "), _c('login'), _vm._v(" "), _c('we-dialog'), _vm._v(" "), _c('div', {
    staticClass: "weui-tab page"
  }, [_c('div', {
    staticClass: "weui-tab__panel"
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-308128b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 191
// module chunks = 2